import $ from 'jquery';
class AnnualReg {

    constructor(){
        if ($("#ann_reg_form").length != 0){
            //this.events();
        }
    }

    events() {
        //  Register Listeners
        $("#reg-year").on("change", this.yearChanged.bind(this));
    }
    //  Methods
    yearChanged(e){
    }
}
export default AnnualReg;